import { useBreakpointValue } from 'utils/mediaQuery';
export const useSearchSplitLayout = ({ isPreviewing, }) => {
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const leftColumnSize = isSmallScreen ? (isPreviewing ? '0' : '100%') : '40%';
    const rightColumnSize = isSmallScreen ? (isPreviewing ? '100%' : '0') : '60%';
    return { leftColumnSize, rightColumnSize };
};
